import React, { useContext, useState } from 'react';
import { ContextProps } from '../types/ContextProps';

type DateContextType = {
    manuallySetLocalTime: Date | null;
    portCash: any;
    setManuallySetLocalTime: (date: Date) => void;
    setPortCash: (delta: any) => void;
};

export const DateContext = React.createContext<DateContextType>(undefined!);

export const DateProvider = ({ children }: ContextProps) => {
    const [manuallySetLocalTime, setManuallySetLocalTime] = useState<Date | null>(null);
    const [portCash, setPortCash] = useState<any>({});

    return (
        <DateContext.Provider
            value={{
                manuallySetLocalTime,
                setManuallySetLocalTime,
                portCash,
                setPortCash,
            }}
        >
            {children}
        </DateContext.Provider>
    );
};

export const useDateStore = () => useContext(DateContext);
